<script>
  import { boolean } from '@st-graphics/graphics-kit/utils'
  import {
    Headline,
    Photo,
    ImageSlider,
    ScrollDownMessage,
    Video,
  } from '@st-graphics/graphics-components'

  let {
    navbar,
    byline,
    datetime,
    modifieddatetime,
    deck,
    headline,
    mobiledeck = 'true',
    src,
    fullscreenmode = 'image',
    hasdesktop = 'true',
    alt,
    classname = '',
    scrolldownicon = 'true',
    menuitems,
    balancehed = true,
    balancedek = true,
    slides = [],
    slidetime = 5000,
    autoplay = true,
    loop = true,
    poster = undefined,
  } = $props()
</script>

<div class="nav">
  {@render navbar?.()}
  {@render menuitems?.()}
</div>

<div class={`article-head ${classname}`}>
  <div class="main-headline-head-wrapper fullscreen-img">
    <div class="article-hero" style="--height:100%">
      {#if fullscreenmode === 'image'}
        <Photo {src} {alt} hasDesktop={boolean(hasdesktop)} />
      {:else if fullscreenmode === 'slider'}
        <ImageSlider
          {slides}
          hasdesktop={boolean(hasdesktop)}
          duration={slidetime}
          aspectratio="1.5 / 1"
        />
      {:else if fullscreenmode === 'video'}
        <Video
          {src}
          {alt}
          hasdesktop={boolean(hasdesktop)}
          {autoplay}
          {loop}
          {poster}
          controls={false}
        />
      {/if}
    </div>

    <div class="article-headline">
      <Headline
        hed={headline}
        dek={deck}
        {byline}
        {datetime}
        {modifieddatetime}
        mobiledeck={boolean(mobiledeck)}
        balancehed={boolean(balancehed)}
        balancedek={boolean(balancedek)}
      />

      {#if scrolldownicon === 'true'}
        <ScrollDownMessage />
      {/if}
    </div>
  </div>
</div>

<style lang="scss">
  .nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;
    --navbar-color: var(--st-white);
    --brand-color: currentcolor;

    :global(a),
    :global(.menu) {
      color: #fff !important;
    }
  }

  .article-head {
    --article-head-color: var(--st-white);
    --article-head-hero-overlay-background-color: rgb(0 0 0 /50%);
    position: relative;
    height: var(--article-head-hero-height, 100vh);
    color: var(--article-head-color);
    text-align: var(--article-head-text-align);
    background-size: cover;

    :global(.headline .wrapper:last-of-type) {
      border: none;
    }
  }

  .main-headline-head-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    --headline-dek-color: #fff;
    --byline-color: #fff;
  }

  .article-hero {
    position: absolute;
    width: 100%;
    height: 100vh;
    margin: 0 auto;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: var(--article-head-hero-height, 100vh);
      content: '';
      background-color: var(--article-head-hero-overlay-background-color);
    }

    :global(figure) {
      width: 100%;
      height: 100%;
    }

    :global(.image-wrapper) {
      height: 100% !important;
    }

    :global(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: var(--article-head-hero-crop-align, 'center');
    }
    :global(.videocontainer) {
      width: 100%;
      height: 100%;
    }
    :global(video) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: var(--article-head-hero-crop-align, 'center');
    }
  }

  .article-headline {
    position: relative;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 114px; // Scroll message margin-top (50) + height (64)
    pointer-events: none;
    --link-color: #fff;
    --link-text-decoration-color: #fff;

    :global(.headline) {
      pointer-events: all;
    }
  }
</style>
